import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Brand from "@/components/Brand";
import { COMPANY } from "@/lib/company";

const AUTH_IMG =
  "https://images.pexels.com/photos/30834164/pexels-photo-30834164.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";

export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      {/* Left visual */}
      <div className="relative hidden lg:block grain">
        <img src={AUTH_IMG} alt="Winter lake and cabins" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-primary/80" />
        <div className="absolute inset-0 bg-gradient-to-t from-primary via-primary/60 to-primary/40" />
        <div className="relative z-10 flex h-full flex-col justify-between p-12" style={{ textShadow: "0 2px 16px rgba(0,0,0,0.45)" }}>
          <Brand light />
          <div className="max-w-md">
            <p className="font-mono-label text-xs text-white/70">Seasonal Protection</p>
            <h2 className="mt-4 font-heading text-4xl font-bold leading-tight text-white">
              Protect your RV before the freeze.
            </h2>
            <p className="mt-4 text-white/80 leading-relaxed">
              Manage your account, verify your details, and reserve your winterizing service in minutes.
            </p>
          </div>
          <p className="font-mono-label text-[10px] text-white/50">© Shoreline RV</p>
        </div>
      </div>

      {/* Right form */}
      <div className="flex items-center justify-center bg-background px-6 py-12">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="w-full max-w-md"
        >
          <div className="mb-8 lg:hidden">
            <Brand />
          </div>
          <h1 className="font-heading text-3xl font-bold tracking-tight text-foreground">{title}</h1>
          {subtitle && <p className="mt-2 text-muted-foreground">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-muted-foreground">{footer}</div>}
          <p className="mt-10 border-t border-border pt-5 text-xs leading-relaxed text-muted-foreground" data-testid="auth-legal-line">
            {COMPANY.ownershipStatement}{" "}
            <Link to="/privacy" className="underline hover:text-primary">Privacy Policy</Link>{" · "}
            <Link to="/terms" className="underline hover:text-primary">Terms of Service</Link>
          </p>
        </motion.div>
      </div>
    </div>
  );
}
